import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  thruWrapper: ({ isEmbedView }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(6),
    color: isEmbedView ? theme.palette.primary.contrastText : '#836F50',
    background: isEmbedView ? theme.palette.ryderCup.neutral : 'unset',
    border: '1px solid #836F50',
    borderRadius: '50%',
    minWidth: '100px',
    height: '100px',
    '& span': {
      color: isEmbedView ? theme.palette.primary.contrastText : '#836F50',
      fontFamily: 'Nunito Sans',
      lineHeight: '1.5',
    },
    '& h4': {
      fontFamily: 'Nunito Sans',
    },
    [theme.breakpoints.down('sm')]: {
      borderRadius: '7px',
      flexDirection: 'row',
      minWidth: '0px',
      height: '30px',
      marginTop: '0px',
      marginLeft: theme.spacing(3),
      padding: theme.spacing(1),
      '& h4': {
        fontFamily: 'Nunito Sans',
        fontSize: '16px',
        fontWeight: '700',
        marginLeft: theme.spacing(1),
      },
      '& span': {
        fontSize: '14px',
      },
    },
  }),
  tee: {
    color: theme.palette.text.secondary,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: theme.spacing(3),
    '& span': {
      fontFamily: 'Nunito Sans',
    },
    [theme.breakpoints.up('md')]: {
      minWidth: '180px',
      '& p': {
        display: 'none',
      },
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '0px',
      flexDirection: 'row',
      '& span': {
        display: 'none',
      },
      '& h5': {
        fontFamily: 'Nunito Sans',
        fontSize: '12px',
        letterSpacing: '1px',
        textTransform: 'uppercase',
        color: 'rgba(0, 0, 0, 0.54)',
        fontWeight: 'bold',
      },
      '& p': {
        margin: '0 8px',
      },
    },
  },
}))

export default useStyles
